interface BulkSendShellProps {
  children: React.ReactNode;
}

export default function BulkSendShell({ children }: BulkSendShellProps) {
  return (
    <div className="flex h-screen flex-col">
      <div className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-3">
        <div>
          <h1 className="text-lg font-semibold text-gray-900">
            WhatsApp Bulk Send
          </h1>
          <p className="text-sm text-gray-500">
            Send an approved template to a list of people
          </p>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-6">{children}</div>
    </div>
  );
}
